export default {
  confirmed: '已確認',
  backToDashboard: '回到主頁',
  viewInvoices: '檢視賬單',
  submitted: '已提交',
  submitAnotherRequest: '提交新的申請',
}
